import * as z from 'zod';

export const ErrorMessages = {
  TOO_SHORT: (length: number): string =>
    `Please enter at least ${length} characters`,
  TOO_LONG: (length: number): string =>
    `Please enter at most ${length} characters`,
  Required: 'Required',
  Email: {
    INVALID: 'Please enter a valid email address.',
    INVALID_SCHOOL: 'Please enter a valid school email address.',
    MUST_BE_EDU: 'Must end with ".edu"',
    MUST_BE_SCHOOL_DOMAIN: 'Must end with school domain',
  },
  Name: {
    MISSING: 'Please provide your first and last name.',
  },
  Password: {
    MISSING: 'Please enter your password.',
    TOO_SHORT: 'Must be at least 8 characters long.',
    MISSING_NUMBER_OR_SYMBOL: 'Must contain a number or symbol.',
  },
  PhoneNumber: {
    INVALID: 'Please enter a valid phone number.',
  },
  ZipCode: {
    INVALID: 'Please enter a 5-Digit Zip Code.',
  },
  GradYear: {
    INVALID: 'Please enter a year between 1900 and 2100',
  },
  Gender: {
    INVALID: 'Please choose a valid gender',
  },
  Diversity: {
    INVALID: 'Please make a selection',
  },
  Affiliation: {
    INVALID: 'Please select what best describes you',
  },
  StudentId: {
    INVALID: 'Please enter a valid student ID',
  },
  OtherAffiliationDetail: {
    INVALID: 'Please enter a valid detail',
  },
  Journey: {
    INVALID: 'Please select a valid classification',
  },
  Department: {
    INVALID: 'Please select a valid department',
  },
  Role: {
    INVALID: 'Please select a valid role',
  },
  PlanToUseCampusLush: {
    INVALID: 'Please enter the plan to use CampusLush',
  },
  GraduationYear: {
    INVALID: 'Please enter a valid graduation year',
  },
  Gpa: {
    INVALID: 'Please enter a valid GPA between 0.0 and 4.0',
  },
  Major: {
    INVALID: 'Please select at least one major',
  },
  Month: {
    INVALID: 'Please choose a valid Month',
  },
  Day: {
    INVALID: 'Please choose a valid Day',
  },
  Time: {
    INVALID: 'Please enter a time as hh:mm',
  },
  Url: {
    INVALID: 'Please enter a valid url',
  },
  EVENTS_INTERESTED: {
    INVALID: 'Please select at least one category',
  },
  DomainName: {
    INVALID: 'Please enter a valid domain name',
  },
};

export const zFirstName = z.string().nonempty(ErrorMessages.Required);
export const zLastName = z.string().nonempty(ErrorMessages.Required);
export const zEmail = z.string().email(ErrorMessages.Email.INVALID);
export const zPassword = z
  .string()
  .min(8, ErrorMessages.Password.TOO_SHORT)
  .regex(/[^a-zA-Z]/, ErrorMessages.Password.MISSING_NUMBER_OR_SYMBOL);
export const zZipCode = z
  .string()
  .regex(/^[0-9]{5}$/, ErrorMessages.ZipCode.INVALID);
export const zMobileNumber = z
  .string()
  .regex(/^[2-9]\d{9}$/, ErrorMessages.PhoneNumber.INVALID);
